import { render, staticRenderFns } from "./infrastructure.vue?vue&type=template&id=d6340010&scoped=true&"
import script from "./infrastructure.vue?vue&type=script&lang=js&"
export * from "./infrastructure.vue?vue&type=script&lang=js&"
import style0 from "./infrastructure.vue?vue&type=style&index=0&id=d6340010&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6340010",
  null
  
)

export default component.exports